import { FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { LabelXSmall } from 'baseui/typography';
import moment from 'moment';
import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { updatedCurrentStateState } from '../../storage/client';
import { OperationalState } from '../../types/currentState';

type Props = {
  operationalState: OperationalState;
  fillWidth?: boolean;
  withVerticalWhiteSpace?: boolean;
};

function OperationalStatusTime({
  operationalState,
  fillWidth = false,
  withVerticalWhiteSpace = false,
}: Readonly<Props>) {
  const { css, theme } = useStyles();
  const wrapperStyles = css({
    padding: `${withVerticalWhiteSpace ? theme.sizing.scale200 : theme.sizing.scale100} ${theme.sizing.scale300}`,
    background: theme.colors.backgroundSecondary,
    borderRadius: theme.borders.radius200,
    width: fillWidth ? '100%' : 'auto',
  });
  const wrapperProps = {
    classNames: wrapperStyles,
    gap: theme.sizing.scale100,
    centered: true,
  };
  // Triggers re evaluation of time
  useRecoilValue(updatedCurrentStateState);

  if (!operationalState.lastStatusChange) {
    return null;
  }

  const time = moment(+operationalState.lastStatusChange).fromNow(true);

  return (
    <FlexRow {...wrapperProps}>
      <MaterialIcon
        name="schedule"
        size="16px"
        color={theme.colors.contentSecondary}
      />
      <LabelXSmall
        color={theme.colors.contentSecondary}
        style={{ whiteSpace: 'nowrap' }}
      >
        {time}
      </LabelXSmall>
    </FlexRow>
  );
}

export default memo(OperationalStatusTime);
